module.exports = __webpack_public_path__ + "img/uabc_gaceta.06ac3924.png";